import { render, staticRenderFns } from "./MaturityPieChart.vue?vue&type=template&id=72478f13&scoped=true&"
import script from "./MaturityPieChart.vue?vue&type=script&lang=js&"
export * from "./MaturityPieChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72478f13",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/iaai/products/maturity-assessment-tool/mat-website/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72478f13')) {
      api.createRecord('72478f13', component.options)
    } else {
      api.reload('72478f13', component.options)
    }
    module.hot.accept("./MaturityPieChart.vue?vue&type=template&id=72478f13&scoped=true&", function () {
      api.rerender('72478f13', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/MaturityPieChart.vue"
export default component.exports